<template>
  <div class="footer" :style="'height:4.9rem;'">
    <div class="footer-intro">
      <div class="footer-left">
        <img class="logo" alt="长留香" src="../assets/logo.png"/>
        <div class="nav" @click="chooseHandler">
          <span id="0">首页&nbsp; |</span>
          <span id="1"> &nbsp;关于长留香&nbsp; |</span>
          <span id="2"> &nbsp;产品中心&nbsp; |</span>
          <span id="3"> &nbsp;联系我们&nbsp; |</span>
          <span id="4"> &nbsp;百度词条 </span>
        </div>
        <div>官方电话：400-991-3868</div>
      </div>
      <div class="footer-right">
        <div class="go-top" @click="debounceGoTop">返回顶部 ↑</div>
        <div class="footer-official">
          <div class="official-msg" style="margin-left: 0.1rem">
            <div class="official-img">
              <img
                class="Qrcode"
                alt="长留香公众号"
                src="../assets/gongzhonghao.png"
              />
            </div>
            <span
            ><a
              class="link"
              href="http://weixin.qq.com/r/hBxXTw3EIVBerUks90mW"
              target="“_blank”"
            >长留香公众号</a
            ></span
            >
          </div>
<!--          <div class="official-msg" style="margin-left: 0.1rem">-->
<!--            <div class="official-img">-->
<!--              <img-->
<!--                class="Qrcode"-->
<!--                alt="长留香旗舰店"-->
<!--                src=""-->
<!--              />-->
<!--            </div>-->
<!--            <span-->
<!--            ><a-->
<!--              class="link"-->
<!--              href="#"-->
<!--              target="“_blank”"-->
<!--            >长留香旗舰店</a-->
<!--            ></span-->
<!--            >-->
<!--          </div>-->
          <div class="official-msg" style="margin-left: 0.1rem">
            <div class="official-img">
              <img class="Qrcode" alt="天猫酒类专营店" src="../assets/tianmao.png"/>
            </div>
            <span
            ><a
              class="link"
              href="https://haorunjl.tmall.com"
              target="“_blank”"
            >天猫酒类专营店</a
            ></span
            >
          </div>
          <div class="official-msg" style="margin-left: 0.1rem">
            <div class="official-img">
              <img
                class="Qrcode"
                alt="京东酒类专营店"
                src="../assets/jingdong.png"
              />
            </div>
            <span
            ><a
              class="link"
              href="http://mall.jd.com/index-11930770.html"
              target="“_blank”"
            >京东酒类专营店</a
            ></span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="footer-trademark">
      版权所有Copyright © 2024 华海恒辉（深圳）商贸有限公司
      <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025362380号</a>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref } from 'vue'
import router from '@/router/index.js'
import { debounce } from '@/utils/tools'

export default defineComponent({
  name: 'TopNav',
  setup () {
    const state = reactive({
      path: ['/', '/about', '/product', '/contact', '/baiduword']
    })
    const indexId = ref('0')

    function chooseHandler (e) {
      if (indexId.value === e.target.id) {
        window.location.href = window.origin + state.path[e.target.id]
      } else {
        indexId.value = e.target.id
        switch (e.target.id) {
          case '0':
            router.push('/')
            break
          case '1':
            router.push('/about')
            break
          case '2':
            router.push('/product')
            break
          case '3':
            router.push('/contact')
            break
          case '4':
            router.push('/baiduWord')
            break
          default:
            break
        }
      }
    }

    // 防抖
    function debounceGoTop () {
      debounce(goTop(), 1000)
    }

    function goTop () {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop =
          document.documentElement.scrollTop =
            top -=
              50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    }

    return {
      indexId,
      chooseHandler,
      debounceGoTop
    }
  }
})
</script>

<style lang="scss" scoped>
@mixin wh($width, $height) {
  width: $width;
  height: $height;
}

@mixin font($size, $weight, $color) {
  font-size: $size;
  color: $color;
  font-weight: $weight;
}

@mixin bg($url) {
  background-image: url($url);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

a {
  text-decoration: none;
}

.footer {
  width: 100%;
  @include bg("~@/assets/footer.png");
  @include font(0.18rem, 500, #2b324e);

  .footer-intro {
    display: flex;
    justify-content: space-between;
    margin: 0 3.2rem;
    padding-top: 1.85rem;

    .footer-left {
      text-align: left;

      .logo {
        @include wh(1.505rem, 0.5rem);
      }

      .nav {
        position: relative;
        z-index: 2;
        white-space: nowrap;
        margin: 0.23rem 0;

        & span {
          cursor: pointer;
        }
      }
    }

    .footer-right {
      text-align: right;

      .go-top {
        @include font(0.18rem, 400, #2b324e);
        margin-bottom: 0.34rem;
        cursor: pointer;
      }

      .footer-official {
        display: flex;

        .official-msg:nth-child(2) {
          margin-left: 0.05rem;
        }

        .official-msg {
          text-align: center;

          & span {
            font-size: 0.14rem;

            .link {
              color: #2b324e;
            }
          }

          .official-img {
            @include wh(1rem, 1rem);
            background: #ffffff;
            border: 0.01rem solid #707070;
            border-radius: 0.1rem;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 0.1rem;

            .Qrcode {
              @include wh(0.89rem, 0.89rem);
            }
          }
        }
      }
    }
  }

  .footer-trademark {
    margin-top: 0.5rem;
    text-align: center;
    font-size: 0.15rem;
  }
}
</style>
